import { NgxPermissionsService } from 'ngx-permissions';
import { distinctUntilChanged, from, switchMap } from 'rxjs';

export enum Permissions {
  EditCompanyData = 'EditCompanyData',
  EditSectorScoringFormularWeights = 'EditSectorScoringFormularWeights',
  ManageSectorKeywords = 'ManageSectorKeywords',
  Admin = 'Admin',
}

// export in ngx-permissions compatible type format
export const adminPermissions = [Permissions.Admin] as unknown as string[];

export const appPermissions = [
  Permissions.EditCompanyData,
  Permissions.Admin,
  Permissions.EditSectorScoringFormularWeights,
  Permissions.ManageSectorKeywords,
] as unknown as string[];

/**
 * Whether the user may edit company data, for code that cannot use the
 * *ngxPermissionsOnly directive, e.g. to show the edit column of a grid.
 */
export const canEditCompanyData = (permissions: NgxPermissionsService) =>
  permissions.permissions$.pipe(
    switchMap(() =>
      from(permissions.hasPermission(Permissions.EditCompanyData as string))
    ),
    distinctUntilChanged()
  );

/**
 * The route data of the admin pages for NgxPermissionsGuard: the roles that
 * see the admin group of the sidebar; everyone else lands on the home page.
 */
export const ADMIN_PERMISSIONS = {
  only: [
    Permissions.ManageSectorKeywords,
    Permissions.EditSectorScoringFormularWeights,
  ] as string[],
  redirectTo: '/home',
};

/**
 * Whether the user is in the Admin group. Admins may change and share every
 * list; the API checks the same (web-app/api/src/utils/listAccess.ts).
 */
export const isAdmin = (permissions: NgxPermissionsService) =>
  permissions.permissions$.pipe(
    switchMap(() => from(permissions.hasPermission(Permissions.Admin as string))),
    distinctUntilChanged()
  );
